mutation CheckStreamConnection($contentId: ID!) {
  checkStreamConnection(contentId: $contentId) {
    id
    stream {
      id
      liveConnected
    }
  }
}
